import gsap from "../src/js/gsap/src/index.js"
import TextPlugin from "../src/js/gsap/src/TextPlugin.js"
import SplitText from "../src/js/gsap/src/SplitText.js"
import scrollTrigger from "../src/js/gsap/src/ScrollTrigger.js"
import Draggable from "../src/js/gsap/src/Draggable.js"
import InertiaPlugin from "../src/js/gsap/src/InertiaPlugin.js"

gsap.registerPlugin(TextPlugin, SplitText, scrollTrigger, Draggable, InertiaPlugin)